import React from 'react';
import BlogPost from '../components/blog/BlogPost';

const BlogPostPage = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <BlogPost />
    </div>
  );
};

export default BlogPostPage;